var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getLocationLookupBatch from "../../requests/location/getLocationLookupBatch";
/**
 *
 */
var GetLocationLookupBatchCommand = /** @class */ (function (_super) {
    __extends(GetLocationLookupBatchCommand, _super);
    function GetLocationLookupBatchCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisationId string
     * @param labelCollection LabelCollection
     * @return {*}
     */
    GetLocationLookupBatchCommand.prototype.execute = function (locationSampleCollection) {
        var _this = this;
        this.locationSampleCollection = locationSampleCollection;
        this.coordinates = locationSampleCollection.getCoordinatesArray();
        this.coordinatesKeys = this.coordinates.map(function (coordinate) {
            return coordinate.latitude + ',' + coordinate.longitude;
        });
        return getLocationLookupBatch(locationSampleCollection.getCoordinatesArray()).then(function (response) { return _this.then(response); }).catch(function (error) { return _this.catch(error); });
    };
    /**
     *
     * @param response
     */
    GetLocationLookupBatchCommand.prototype.then = function (response) {
        // Update firstPlace and lastPlace attributes for each LocationSampleModel
        this.locationSampleCollection.list.forEach(function (locationSample) {
            try {
                if (response[locationSample.firstCoordinateString]) {
                    locationSample.firstPlace = response[locationSample.firstCoordinateString].erro;
                    locationSample.firstPlace = response[locationSample.firstCoordinateString].success.addresses[0].address.freeformAddress;
                }
            }
            catch (e) { }
            try {
                if (response[locationSample.lastCoordinateString]) {
                    locationSample.lastPlace = response[locationSample.lastCoordinateString].error;
                    locationSample.lastPlace = response[locationSample.lastCoordinateString].success.addresses[0].address.freeformAddress;
                }
            }
            catch (e) { }
        });
    };
    /**
     *
     * @param error
     */
    GetLocationLookupBatchCommand.prototype.catch = function (error) {
    };
    return GetLocationLookupBatchCommand;
}(Command));
export default GetLocationLookupBatchCommand;
